function Logo() {
  return <h1>🏝️ Far Away 🧳</h1>;
}

export default Logo;
